// src/Admin/AdminSignIn.js
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { TextField, Button, Typography, Paper, Box } from "@mui/material";
import { API } from "../config";

export default function AdminSignIn() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      // ✅ Admin portal should ONLY login via admin endpoint
      const res = await fetch(`${API}/api/auth/login-admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        // Your backend uses { message }, sometimes { error }
        const msg = data?.message || data?.error || `HTTP ${res.status}`;
        setError(msg);
        setSubmitting(false);
        return;
      }

      // ✅ Confirm admin role safely (supports multiple shapes)
      const role = String(
        data?.user?.role || data?.user?.userType || data?.userType || ""
      ).toLowerCase();

      if (role && role !== "admin") {
        setError("This account is not an admin.");
        setSubmitting(false);
        return;
      }

      // ✅ Store token in BOTH keys:
      // - adminToken for admin API calls
      // - token to satisfy any existing route guards expecting "token"
      if (data?.token) {
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("token", data.token);
      } else {
        setError("Login succeeded but no token was returned by the server.");
        setSubmitting(false);
        return;
      }

      // Optional: keep these if you use them elsewhere
      localStorage.setItem("role", "admin");
      localStorage.setItem("adminEmail", email);

      // Go to admin area
      history.replace("/admin");
    } catch (err) {
      setError(err?.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      px={2}
    >
      <Paper elevation={3} style={{ padding: 24, maxWidth: 420, width: "100%" }}>
        <Typography variant="h5" gutterBottom>
          Admin Sign In
        </Typography>

        <form onSubmit={onSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
            margin="normal"
            autoComplete="username"
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            margin="normal"
            autoComplete="current-password"
          />

          {error && (
            <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
              {error}
            </Typography>
          )}

          <Box mt={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={submitting}
              fullWidth
            >
              {submitting ? "Signing in…" : "Sign In"}
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
